import { useState } from "react";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/20/solid"
import moment from "moment";

export default function OrganizationInvoiceHistory({
    invoiceHistory = []
}) {

    const [expanded, setExpanded] = useState(false);

    if (invoiceHistory.length === 0) {
        return null;
    }

    return (
        <>
            <div
                className='p-4 flex items-center cursor-pointer'
                onClick={() => setExpanded(!expanded)}
            >
                <div className="flex-1">Invoice History</div>

                <div className="transition-transform duration-300 ease-in-out">
                    {expanded === false && <ChevronDownIcon className="h-6 w-6 text-gray-500" />}
                    {expanded === true && <ChevronUpIcon className="h-6 w-6 text-gray-500" />}
                </div>
            </div>

            <div
                className={`
                    transition-all duration-300 ease-in-out overflow-hidden divide-y divide-gray-200
                    ${expanded ? 'opacity-100' : 'max-h-0 opacity-0'}
                `}
            >
                <div className="divide-y divide-gray-200">
                    {invoiceHistory.filter(invoice => invoice.status === 'paid' && invoice.total > 0).map((invoice, index) => (
                        <div 
                            key={index}
                            className="p-4 flex items-center gap-x-2 bg-gray-50" 
                        >
                            <div className="text-sm flex-1">
                                {/* Adding -5 for hack fix where bills were billed late */}
                                {moment(invoice.created * 1000).local().add(-5, 'day').format('MMMM YYYY')}
                            </div>
                            <div className="px-2 py-0.5 bg-green-100 text-green-700 rounded text-xs font-medium mr-2">Paid</div>
                            <div className="text-sm">${(invoice.total / 100).toFixed(2)}</div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}